import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from '@rocketlane/rocket-router';
import styled from 'styled-components';
import { NitroClawDesktopSidebar } from 'components/organisms/nitro-claw/nitro-claw-desktop-sidebar';
import { useQuickEntryBridge } from 'hooks/use-quick-entry-bridge';
import { useSyncQuickEntryNative } from 'hooks/use-quick-entry-config';
import { useDismissBootSkeleton } from 'utils/dismiss-boot-skeleton';
const DesktopShellRoot = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  background: var(--page-background);
`;
const DesktopShellOutlet = styled.div`
  flex: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /*
   * Page (molecules/page) is inset + rounded for web LeftNav chrome.
   * In the desktop shell the Nitro Claw sidebar already provides the rail,
   * so flush #page to the outlet top/edges (Projects, Notifications, etc.).
   */
  #page {
    height: 100% !important;
    max-height: 100%;
    padding: 0 !important;

    & > *:first-child {
      border-radius: 0 !important;
    }

    & > *:last-child {
      border-radius: 0 !important;
    }
  }
`;
/**
 * Full-viewport Nitro Claw chrome — sidebar + outlet.
 * Used in Tauri always, and on web when `app-shell-mode` is `nitro-claw`.
 */ export const DesktopAppShell = ()=>{
    useDismissBootSkeleton(true);
    useQuickEntryBridge();
    // Push shortcut / background prefs to Rust while the main shell is mounted.
    useSyncQuickEntryNative();
    return /*#__PURE__*/ _jsxs(DesktopShellRoot, {
        "data-cy": "desktop-app-shell",
        children: [
            /*#__PURE__*/ _jsx(NitroClawDesktopSidebar, {}),
            /*#__PURE__*/ _jsx(DesktopShellOutlet, {
                children: /*#__PURE__*/ _jsx(Outlet, {})
            })
        ]
    });
};
